import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/ManageUsers/Invite/Views/invite.html";
import { trekService } from "@/Pages/Admin/Modules/ManagePackage/Services/Trekservice";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";
import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";

import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";

@WithRender
@Component({
  components: {
    "validation-error": ValidationError
  }
})
export default class Invite extends Vue {
  protected ui: any = {};
  protected errors: any = {};
  protected errorsMessage: any = {};
  protected InviteUser: any = {};
  protected isError: boolean = false;
  protected Disable: any = {};
  constructor() {
    super();
    this.Disable.save = false;
    this.ui.IsLoading = false;
    this.ui.PostLoading = false;

    this.InviteUser.Email = "";
    this.InviteUser.FirstName = "";
    this.InviteUser.LastName = "";
  }
  public inviteUser() {
    this.isError = false;
    this.Disable.save = true;
    this.errors = {};
    if (!this.IsValidationTrue()) {
      return;
    }
    // alert(this.email);
    let data = {
      firstname: this.InviteUser.FirstName,
      lastname: this.InviteUser.LastName,
      email: this.InviteUser.Email
    };
    // console.log(payLoad);
    this.ui.PostLoading = true;
    trekService
      .addSendInvitation(data)
      .then((res: any) => {
        // console.log(res.data.data);
        // this.DepartureList.push(res.data.data);
        this.Disable.save = false;
        flashService.Success("Invitatin Sent", res.data.message);
        // // this.Message = res.data.message;
        // this.DepartureList.unshift(res.data.data);
        this.$router.push({
          name: "user-pending-invite"
        });
        this.InviteUser.Email = "";
        this.InviteUser.FirstName = "";
        this.InviteUser.LastName = "";
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.errorsMessage).then(res => {
          this.errorsMessage = res;
        });
        // flashService.Error('Error', 'Error while saving Departure');
      })
      .finally(() => {
        this.ui.PostLoading = false;
      });
  }
  protected IsValidationTrue() {
    if (!this.InviteUser.Email) {
      Object.assign(this.errors, { email: ["The email field is required."] });
    }
    if (!this.InviteUser.FirstName) {
      Object.assign(this.errors, {
        firstName: ["The First name is required."]
      });
    }
    if (!this.InviteUser.LastName) {
      Object.assign(this.errors, { lastName: ["The Last name is required."] });
    }
    if (common.notEmpty(this.errors)) {
      this.isError = true;
      return false;
    } else {
      return true;
    }
  }
}
